import { AppPageComponent } from '../../shared/ui';
import { Thread } from '../models';
import { UserService } from '../../shared/services/';
import { HeaderAction, TopLevelComponent } from '../../shared/models';
import { Store, StoreHelper } from '../../shared/services';
import { ChatService } from '../chat.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import * as moment from 'moment';

const dateFormat = 'MM/DD/YYYY hh:mm:ss A';

@Component({
    selector: 'nova-chatindex',
    template: require('./chat-index.component.pug')
})
export class ChatIndexComponent extends TopLevelComponent implements OnInit, OnDestroy {
    @ViewChild(AppPageComponent) appPage;
    threads: Thread[] = [];
    private updateThreadSub: Subscription;

    private _chatAction = { id: 'join', icon: 'comment' };

    public static populateThreadsWithTimestamp(threads: Thread[]) {
        threads.forEach( t => {
            if (t.messages.length > 0) {
               return t.timestamp = moment(t.messages[t.messages.length - 1].timestamp).format(dateFormat);;
            }
        });
    }

    constructor(private _router: Router,
                storeHelper: StoreHelper,
                store: Store,
                userService: UserService,
                private _chatService: ChatService
                ) {
      super(store, storeHelper, userService);
 }

    ngOnInit() {
       this.subscribeToHeaderActions(this._reactToHeaderAction); 
       this.threads = this._chatService.threads; 
       this.headerTitle = 'CHAT';
       this.headerActions = [ this._chatAction ];
       this.subscribeToHeaderActions(this._reactToHeaderAction);

       ChatIndexComponent.populateThreadsWithTimestamp(this.threads);

       this.threads = this._chatService.threads;
       if (this._chatService.threads.length > 1) {
           this.updateThreadSub = this._chatService.pullThreadsLastMessage()
           .subscribe(() => this.appPage.deactivatePreloader());
       } else {
           this.appPage.deactivatePreloader();
       }
    }

    private _reactToHeaderAction(action: HeaderAction) {
        if (action.id === this._chatAction.id) {
            this._router.navigate(['chat/joinregion']);
        }
    }

    ngOnDestroy() {
        if (this.updateThreadSub) {
            this.updateThreadSub.unsubscribe();
        }
    }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/chatindex/chat-index.component.ts